import React from 'react';
import { Form, Popover, OverlayTrigger } from 'react-bootstrap';
import { Edit, Warning } from '@material-ui/icons';

export default class LedmoduleFeatureListItem extends React.Component {

    render() {

        let label = `${this.props.ledmoduleFeature.displayName}`;

        let issueComponent = null;
        if (this.props.errors && this.props.errors.length > 0) {

            let errors = [];
            this.props.errors.forEach(error => {
                if (error.name && errors.indexOf(error.name) === -1) {
                    errors.push(error.name + ': ' + error.description);
                }
            });

            if (errors.length > 0) {
                const popover = (
                    <Popover id="popover-basic">
                        <Popover.Title as="h3" className="error-popover" >Errors</Popover.Title>
                        <Popover.Content>
                            {errors.join(", ")}
                        </Popover.Content>
                    </Popover>
                );

                issueComponent = (
                    <OverlayTrigger placement="right" trigger="click" overlay={popover}>
                        <Warning style={{ margin: 'auto', color: '#dc3545' }} />
                    </OverlayTrigger>
                );
            }
        }

        if (issueComponent === null && this.props.warnings && this.props.warnings.length > 0) {

            let warnings = [];
            this.props.warnings.forEach(warning => {
                if (warning.name && warnings.indexOf(warning.name) === -1) {
                    warnings.push(warning.name + ': ' + warning.description);
                }
            });

            if (warnings.length > 0) {
                const popover = (
                    <Popover id="popover-basic">
                        <Popover.Title as="h3" className="error-popover" >Warnings</Popover.Title>
                        <Popover.Content>
                            {warnings.join(", ")}
                        </Popover.Content>
                    </Popover>
                );

                issueComponent = (
                    <OverlayTrigger placement="right" trigger="click" overlay={popover}>
                        <Warning style={{ margin: 'auto', color: '#f0ad4e' }} />
                    </OverlayTrigger>
                );
            }
        }

        const edited = this.props.edit ? <Edit /> : null;

        const classNameDiv = this.props.isSelected ? 'div-ledmodule-feature-listitem-selected' : 'div-ledmodule-feature-listitem';
        const classNameGroup = this.props.isSelected ? 'form-ledmodule-feature-listitem-selected' : 'form-ledmodule-feature-listitem';

        return (
            <div className={classNameDiv} >
                <Form.Group
                    className={classNameGroup}
                    style={{ display: 'flex', cursor: 'default', paddingLeft: '1rem' }}
                    onClick={(e) => this.props.onShowFeature(e, this.props.ledmoduleFeature)} >

                    {label}
                    {issueComponent}
                    {edited}
                </Form.Group>

            </div>
        );
    }
}